import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from './environments/environment';
import { RootComponent } from './app/root/root.component';
import { rootConfig } from './app/root/root.config';
import posthog from 'posthog-js';
import { API_GRAPHQL_ENDPOINT, API_SERVER_URL, API_SUBSCRIPTION_ENDPOINT } from './token';

if (environment.production) {
  enableProdMode();

  posthog.init(environment.posthogKey!, {
    api_host:environment.posthogHost,
    person_profiles: 'always', // or 'always' to create profiles for anonymous users as well
    defaults: '2025-05-24',
    autocapture: false,
  })
}

async function loadConfig() {
  try {
    const res = await fetch('/assets/config.json');
    return res.json();
  } catch {
    // fallback if config.json missing
    return {
      graphQLEndpointOverride: "",
      subscriptionEndpointOverride: "",
      serverUrlOverride: ""
    };
  }
}

(async () => {

  const config = await loadConfig();

  bootstrapApplication(RootComponent, {
    ...rootConfig,
    providers: [
      ...rootConfig.providers,
      // Use override if exists, fallback to environment
      {
        provide: API_SERVER_URL,
        useValue: config.serverUrlOverride || environment.serverUrl
      },
      {
        provide: API_GRAPHQL_ENDPOINT,
        useValue: config.graphQLEndpointOverride || environment.graphQLEndpoint
      },
      {
        provide: API_SUBSCRIPTION_ENDPOINT,
        useValue: config.subscriptionEndpointOverride || environment.subscriptionEndpoint
      },
    ]
  }).catch((err) => console.error(err));

})();
